// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper__3_MNH","box":"Loader_box__1N-2Z"};